<template>
  <div>
    <div class="back" @click="back">
      <i></i>
      <span>返回</span>
    </div>
    <div class="stepcontent">
      <div
        class="stepitem"
        v-for="(item, index) in progressbartitle"
        :key="index"
        :class="{ steptwo: !(index <= isShowActive) }"
      >
        <span>{{ index + 1 }}{{ item }}</span>
      </div>
    </div>
    <div class="konghuang"></div>
    <transition name="fade-transform">
      <keep-alive :include="keepdata">
        <component
          ref="childrenref"
          :is="coms"
          :nextPage="nextPage"
        ></component>
      </keep-alive>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newExamInfo: {
        ExamName: "",
        PaperModeExam: "",
        PaperModeName: "",
        BeginTime: "",
        EndTime: "",
        ExamID: "",
      },
      isShowActive: 0,
      keepdata: ["Pageone", "Pagefour"], //需要加载缓存的组件，默认全部缓存./
      progressbartitle: [".创建考试", ".考场/考生设置"],
    };
  },
  props: ["cutcoms"],
  components: {
    Pageone: () => import("./components/pageone.vue"),
    Pagefour: () => import("./components/pagefour.vue"),
  },
  computed: {
    coms() {
      switch (this.isShowActive) {
        case 0:
          return "Pageone";
        case 1:
          return "Pagefour";
      }
      return "ss";
    },
  },
  methods: {
    nextPage: function (index) {
      this.isShowActive = index;
    },
    back() {
      let confriemdata = this.$confirm(
        "试卷尚未组完，退出后将不保存组卷信息，是否退出?",
        "温馨提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          // this.cutcoms(0);
          if (this.$route.query.trainId) {
            // 培训过来的
            this.$router.push({
              path: this.$route.query.toUrl,
              query: {
                trainId: this.$route.query.trainId,
                toUrl: this.$route.query.toUrl,
                state: "xxqk",
              },
            });
          } else {
            this.cutcoms(0);
          }
          this.$destroy();
        })
        .catch(() => {});
      return confriemdata;
    },
  },
  created() {
    console.log("=====拷贝父级examInfo数据=====", this.$parent.examInfo);
    this.$objCopy.objCoppy(this.$parent.examInfo, this.newExamInfo);
    this.newExamInfo.ExamName = this.newExamInfo.ExamName + "（补考）";
  },
};
</script>

<style lang="scss" scoped>
.back {
  border-bottom: 1px solid #f8f8f8;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
.stepcontent {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 88px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  background-color: #fff;
}
.stepitem {
  height: 45px;
  background-color: #1890ff;
  border-radius: 45px 45px 45px 45px;
  overflow: hidden;
  position: relative;
  &:nth-child(1) {
    transform: translate(90px);
    z-index: 20;
    &::before {
      background-color: #1890ff;
    }
  }
  &:nth-child(2) {
    transform: translate(45px);
    z-index: 10;
  }
  &:nth-child(3) {
    //transform: translate(45px);
    z-index: 5;
  }
  &:nth-child(4) {
    transform: translate(-45px);
    z-index: 1;
  }
  &:nth-child(5) {
    transform: translate(-90px);
    z-index: 0.5;
  }
  &::before {
    display: inline-block;
    position: absolute;
    content: "";
    width: 60px;
    height: 60px;
    background-color: rgb(255, 255, 255);
    border-radius: 50% 50%;
    transform: translate(-8px, -7px);
  }
  span {
    display: inline-block;
    width: 100%;
    line-height: 45px;
    text-align: center;
    font-size: 16px;
    font-family: PingFang SC;
    color: #ffffff;
    padding-left: 71px;
    padding-right: 71px;
  }
}
.konghuang {
  height: 24px;
  background-color: #f8f8f8;
}
.steptwo {
  background-color: #eeeeee;
  span {
    color: #bbbbbb !important;
  }
}
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.5s;
}

/*
enter定义进入过渡的开始状态
 */
.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}
/*
leave-to离场动画结束后的状态
 */
.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
